import { render, staticRenderFns } from "./ViewFundPage.vue?vue&type=template&id=4e68937e&"
import script from "./ViewFundPage.vue?vue&type=script&lang=ts&"
export * from "./ViewFundPage.vue?vue&type=script&lang=ts&"
import style0 from "./ViewFundPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports